export const COMMON_LOGIN_MODAL = 'AUTH_MODAL_OPEN';
export const OPEN_DEPOSIT_PROTECTION_MODAL = 'open_deposit_protection_modal';

export const OFFER_BOX_INFO = 'OFFER_BOX_INFO';
export const OFFER_BOX_EXPIRATION_TIME = 48;
export const DELAY_TOAST_IN_MS = 30000;

export const OFFER_MODAL_MUST_SHOW = 'offer_modal_must_show';
export const OPEN_MODAL_EVENTS = {
  open: {
    eventCategory: 'signup/login modal',
    eventAction: 'TemporalDiscount',
    eventLabel: 'open'
  },
  close: {
    eventCategory: 'signup/login modal',
    eventAction: 'TemporalDiscount',
    eventLabel: 'close'
  }
};

export const CHANNELS = {
  COMMON_LOGIN_MODAL,
  OPEN_DEPOSIT_PROTECTION_MODAL
};
